import { render, staticRenderFns } from "./OrganismEditionSectionNavigation.vue?vue&type=template&id=2bce8c12&"
import script from "./OrganismEditionSectionNavigation.vue?vue&type=script&lang=js&"
export * from "./OrganismEditionSectionNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports